/**
 * Loader Component
 */

import React from 'react';
import './Loader.scss';

const Loader = ({ 
  size = 'md', 
  color = 'primary', 
  fullScreen = false,
  text = null 
}) => {
  const sizeClasses = {
    sm: 'loader--sm',
    md: 'loader--md',
    lg: 'loader--lg',
  };
  
  const loader = (
    <div className={`loader ${sizeClasses[size]} loader--${color}`}>
      <div className="loader__spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {text && <p className="loader__text">{text}</p>}
    </div>
  );
  
  if (fullScreen) {
    return (
      <div className="loader-overlay">
        {loader}
      </div>
    );
  }
  
  return loader;
};

export default Loader;
